// 404.js
import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/NotFound.css';

const NotFound = () => {
    return (
        <div className="notfound-container">
            <div className="notfound-card">
                <h1 className="notfound-title">
                    <i className="fa-solid fa-triangle-exclamation"></i> 404
                </h1>
                <p className="notfound-text">
                    Oops! The page you are looking for does not exist or has been moved.
                </p>
                <Link to="/" className="notfound-btn">Go Back Home</Link>
            </div>
        </div>
    );
};

export default NotFound;
